<div class="col-md-12" class="full-width">
  <div class="text-center add-padding">
    <div class="add-padding">
      <i class="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i>
    </div>
    <p class="add-padding" translate>ERROR_PROFILE_LOAD</p>
    <button class="btn btn-default add-right-margin" (click)="tryAgain()" translate>TRY_AGAIN</button>
  </div>
</div>
